<template lang="pug">
  router-link.ephemeride-card.relative.row(:to='ephemerideLink')
    img.ephemeride-img.absolute(:src='image' :alt='name')
    .shadow.absolute
    .date.absolute
      span.text-small.date-text.bold.white {{ formatedDate }}
    .container.column.bottom
      h4.uppercase.text-normal.bold.white.m-bottom-05 {{ name }}
      router-link.text-normal.white.underline(:to='ephemerideLink')
        | {{ $t("sdg.seeCollection") }}
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { routes } from '../router'
import { localesToMoment } from '../constants/languages'

export default {
  props: {
    name: { type: String },
    image: { type: String },
    startDate: { type: [Date, String] },
    id: { type: Number },
    folderLocale: { type: String }
  },
  computed: {
    ...mapState({
      locale: state => state.behavior.locale
    }),
    formatedDate() {
      return moment(this.startDate)
        .locale(localesToMoment[this.locale])
        .format('MMM DD')
        .replace('.', '')
        .toUpperCase()
    },
    ephemerideLink() {
      return {
        name: routes.search,
        query: {
          ...this.$route.query,
          ephemerideLocale: this.folderLocale,
          ephemerideId: this.id
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.ephemeride-card{
  height: 200px;
  border-radius: 8px;
  overflow: hidden;
  .shadow{
    height: 100%;
    width: 100%;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, rgba(0,0,0,0) 70%);
  }
  .container{
    padding: 16px;
    z-index: 1;
  }
  .date{
    background-color: $black;
    padding: 16px;
    border-radius: 0 0 8px 0;
    .date-text{
      display: table-caption;
    }
  }
  .ephemeride-img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
